import React, { useState } from 'react';
import styles from './AboutMeEmployments.module.sass';
import cn from 'classnames';
import AboutMeDescriptionDisplay from './AboutMeDescriptionDisplay';

const AboutMeEmployments = ({ employments }) => {
  const [openSections, setOpenSections] = useState([]);

  const months = [
    'styczeń',
    'luty',
    'marzec',
    'kwiecień',
    'maj',
    'czerwiec',
    'lipiec',
    'sierpień',
    'wrzesień',
    'październik',
    'listopad',
    'grudzień',
  ];

  const getMonth = month => {
    for (let i = 0; i < months.length; i++) {
      if (i === month) {
        return months[i];
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={cn('title-green', styles.header)}>Kariera zawodowa</div>
      {employments?.length > 0 ? (
        <div className={styles.employments_section}>
          {employments?.map((item, index) => (
            <div className={styles.employments_container} key={index}>
              <div className={styles.employments_list}>
                <div className={styles.image}>
                  <img src={'/images/Employments.png'} alt='Employment' />
                </div>
                <div className={styles.information}>
                  <div className={styles.company_name}>
                    {item?.company_name}
                  </div>
                  <div className={styles.position}>{item?.position}</div>
                  <div className={styles.date}>
                    {new Date(item?.start_date).getUTCDate()}{' '}
                    {getMonth(new Date(item?.start_date).getUTCMonth())}{' '}
                    {new Date(item?.start_date).getUTCFullYear()} -{' '}
                    {new Date(item?.end_date).getUTCDate()}{' '}
                    {getMonth(new Date(item?.end_date).getUTCMonth())}{' '}
                    {new Date(item?.end_date).getUTCFullYear()}
                  </div>
                </div>
                <AboutMeDescriptionDisplay
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                  index={index}
                />
              </div>
              {openSections.includes(index, 0) && (
                <div className={styles.description}>{item?.description}</div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.no_information}>
          Brak informacji o karierze zawodowej.
        </div>
      )}
    </div>
  );
};

export default AboutMeEmployments;
